"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenDialog = void 0;
const React = __importStar(require("react"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const theme = (0, styles_1.unstable_createMuiStrictModeTheme)({
    palette: {
        primary: {
            main: "#125e9f",
        },
    },
});
const KodenDialog = ({ id, title, titleActions, open, onOk, onClose, disabledOk, isLoading, children, dialogActions, showOkButton = true, showCancelButton = true, maxWidth = true, scroll = "paper", fullScreen = false, }) => {
    return (React.createElement(styles_1.ThemeProvider, { theme: theme },
        React.createElement(material_1.Dialog, { open: open, onClose: () => {
                if (!isLoading) {
                    onClose();
                }
            }, maxWidth: maxWidth ? "sm" : false, disableEscapeKeyDown: isLoading, scroll: scroll, fullScreen: fullScreen },
            React.createElement(material_1.DialogTitle, { id: id },
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    } },
                    title,
                    titleActions)),
            React.createElement(material_1.DialogContent, null, children),
            React.createElement(material_1.DialogActions, null,
                dialogActions,
                showCancelButton && (React.createElement(material_1.Button, { onClick: onClose, color: "primary", disabled: isLoading }, "\u53D6\u6D88")),
                showOkButton && (React.createElement(material_1.Button, { onClick: onOk, color: "primary", disabled: disabledOk || isLoading }, isLoading ? "處理中..." : "確定"))))));
};
exports.KodenDialog = KodenDialog;
exports.default = exports.KodenDialog;
//# sourceMappingURL=koden-dialog.js.map